import React, { useState } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { samplePages } from './sampleData';
import { ComingSoon, PageHeading, StatCards, useBasic } from './ui';

const STATUS_WORDS = /active|confirmed|pending|enabled|configured|ai handled|missed/i;

/** A section that has no backend yet: the planned layout with sample data, and its actions marked "coming soon". */
export default function SamplePage({ section }) {
  const basic = useBasic();
  const { notify, upgrade, upgradePlan } = basic;
  const page = samplePages(basic)[section];
  const [search, setSearch] = useState('');
  const rows = page.rows.filter((row) => row.join(' ').toLowerCase().includes(search.toLowerCase()));
  const act = (action) => (/compare plans/i.test(action) ? upgrade() : notify(`${action} is coming soon.`));

  return (
    <section className="page-view">
      <PageHeading title={page.title} subtitle={page.subtitle}>
        <button className="primary-action" onClick={() => act(page.actions[0])}><span>＋</span>{page.actions[0]}</button>
      </PageHeading>
      <div className="preview-banner">
        <b>Preview</b> This section is coming soon. The figures below are sample data to show how it will look.
      </div>
      <StatCards stats={page.stats} />
      <div className="page-toolbar">
        <div className="page-search"><Search size={15} /><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={`Search ${page.title.toLowerCase()}...`} /></div>
      </div>
      <section className="panel page-table-panel">
        <div className="panel-heading">
          <div><h2>{page.title} overview</h2><small className="table-subtitle">Showing {rows.length} items · Sample data</small></div>
        </div>
        <div className="table-scroll">
          <table className="full-page-table">
            <thead><tr>{page.columns.map((col) => <th key={col}>{col}</th>)}</tr></thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>
                      {j === row.length - 1 && (STATUS_WORDS.test(cell) || cell === upgradePlan)
                        ? <span className={`status ${/pending/i.test(cell) || cell === upgradePlan ? 'pending' : /missed/i.test(cell) ? 'red' : 'green'}`}>{cell}</span>
                        : cell}
                    </td>
                  ))}
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={page.columns.length} className="empty-state">No matching records found.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
      <div className="page-bottom-grid">
        <section className="panel page-info-card">
          <div className="panel-heading"><h2>Quick actions</h2></div>
          <div className="page-action-list">
            {page.actions.map((action, i) => (
              <button key={action} onClick={() => act(action)}>
                <span className={`action-dot dot-${i % 4}`}>{['↗', '＋', '⚙', '✓'][i % 4]}</span>
                <span><b>{action}</b>{/compare plans/i.test(action) ? <small>See what each plan includes</small> : <ComingSoon />}</span>
                <ArrowRight size={14} />
              </button>
            ))}
          </div>
        </section>
        <section className="panel page-info-card">
          <div className="panel-heading"><h2>Plan access</h2><span className="active-pill"><i />{basic.plan}</span></div>
          <p className="access-copy">Plan limits and feature access are enforced by the TeleCalX API.</p>
          <button className="upgrade-full" onClick={upgrade}>Review subscription <ArrowRight size={14} /></button>
        </section>
      </div>
    </section>
  );
}
